import { createModalRootComponent } from '../../../common/modals/framework/components/modal-root';
import { modalComponentMapByType } from './modal-component-map-by-type';

export default createModalRootComponent({ modalComponentMapByType });
